<template>
    <div class="vd__menu_nav">
        <div class="vd__menu_logo"></div>
        <div class="vd__menu_items">
            <div class="vd__menu_item" :class="{ 'active': location === item.path }"
            v-for="item in menu"
            :key="item.name"
            v-if="item.menu">
              <router-link :to="item.path">{{ $t(item.label) }}</router-link>
            </div>
        </div>
        <div class="vd__menu_account">
            <div class="vd__help_button">
                <a-icon type="question-circle" />
            </div>
            <div class="vd__menu_dropdown_account">
                <a-dropdown style="display: flex;">
                    <a class="ant-dropdown-link vd__menu_account_text">
                        <div class="vd__account_username">
                          <div class="vd__account-name">{{ name }}</div>
                          <div class="vd__account-email">{{ $store.getters['global/email'] }}</div>
                        </div>
                        <a-icon type="down"/>
                    </a>
                    <a-menu slot="overlay" class="vd__dropdown_account">
                        <!-- <a-menu-item
                        v-for="item in account"
                        :key="item.name"
                        v-if="item.menu"
                        @click="$store.dispatch('global/toPage', item.name)">
                            <a href="javascript:;">{{ $t(item.label) }}</a>
                        </a-menu-item> -->
                        <a-menu-divider />
                        <a-menu-item @click="logout">
                          <a href="javascript:;">
                            {{ $t('menu.account.logout') }}
                          </a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import routes from '../plugins/vue-router';
import Auth from '../plugins/auth';

export default {
  computed: {
    menu() {
      return routes.options.routes[0].children;
    },
    account() {
      return true; //routes.options.routes[0].children[5].children;
    },
    location() {
      return window.location.pathname;
    },
    name() {
      return `${this.$store.getters['global/firstname']} ${this.$store.getters['global/lastname']}`;
    },
  },
  methods: {
    async logout() {
      // eslint-disable-next-line max-len
      const refreshToken = window[this.$authorization.storage].getItem(this.$authorization.keys.refreshToken);
      this.$authorization.logout();
      await this.$router.push({ name: 'login' });
      this.$notification.success({ message: 'Sesión cerrada' });
      await this.axios.post('/auth/logout', null, {
        headers: { Authorization: `Bearer ${refreshToken}` },
      });
      delete this.axios.defaults.headers.common.Authorization;
    },
  },
};
</script>

<style>
.vd__menu_nav{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 3%;
}

.vd__menu_logo{
    width: 45px;
    height: 45px;
    margin-right: 20px;
}

.vd__menu_logo:after{
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    background: url('../assets/img/icon.svg') no-repeat center center / contain;
}

.vd__menu_items{
    width: auto;
    height: 100%;
    flex-grow: 2;
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.vd__menu_item{
    width: auto;
    height: 100%;
    font-size: 1em;
    font-weight: 600;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
}

.vd__menu_item > a {
  width: 100%;
  height: 100%;
  color: white;
  padding: 5px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
}

.vd__menu_item > a:hover {
  opacity: 1;
}

.vd__menu_item > .router-link-active {
  text-decoration: none;
  opacity: 1;
}

.vd__menu_item:hover{
    opacity: 1;
}

.vd__menu_account{
    width: auto;
    height: 100%;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 10px;
}

.vd__help_button{
    width: 30px;
    height: 30px;
    margin-right: 10px;
    font-size: 0.9em;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.vd__menu_account_text, .vd__menu_account_text:hover{
    color: white;
    font-weight: 600;
}

.vd__account_username{
  padding-right: 10px;
  text-transform: capitalize;
}

.vd__account-email {
  font-size: 0.8em;
  font-weight: normal;
  text-transform: none;
}

.vd__dropdown_account{
    transform: translateY(16px) translateX(-13px);
    border-radius: 0 0 4px 4px;
  cursor: pointer;
}

.vd__menu_item.active{
  opacity: 1;
}
</style>
